
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, Grid, DialogActions, Button}from "@material-ui/core";
import { compose } from "recompose";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { TextFieldEditor } from "../../../dataGrid/cellEditors";
import  MESSAGES from "../../../../appMessages";
import styles from "./ModalStyle";
import { withAppConfig } from '../../../../appConfigContext';

class MergeRoutesDialog extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            error: null
        }
    }

    confirm = () => {
        if(this.isValid()){
            this.props.confirm({
                    selectedRoutes:this.props.selectedRoutes,
                    mergedRouteName: this.editorRef.getValue()
                });
            this.props.close();
        }
    }

    isValid = () => {
        const mergedRouteName = this.editorRef.getValue()
        if(!mergedRouteName){
            this.setState({
              error: `Invalid route name. ${this.props.configJSON?.routeNameEditParams.placeholder}`,
            });
        } else if(this.props.routesList.find(route => route.routeName === mergedRouteName) && !this.props.selectedRoutes.find(route => route.routeName === mergedRouteName)){
            this.setState({
                error: MESSAGES.ROUTE_MERGE.ROUTE_EXIST
            });
        } else{
            this.setState({
                error: null
            });
            return true;
        }
        return false;
    }

    onRouteNameChange = (routeName) =>{
        this.setState({
            error: null
        })
    }

    render(){
        const { classes, selectedRoutes } = this.props;
        return(
            <div>
                <Dialog
                    open={true}
                    onClose={this.props.close}
                    aria-labelledby="popup-title"
                    classes = {{paper: classes.dialog}}
                    maxWidth= 'sm'
                >
                    <DialogTitle id="popup-title" classes={{root: classes.dialogTitle}} disableTypography >
                        Merge Routes
                        <IconButton aria-label="Close" classes={{root:classes.closeIcon}} onClick={this.props.close}>
                             <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent  classes={{root:classes.dialogContent}}>
                        <Grid container spacing={24}>
                            <Grid item xs={12} classes={{root: classes.message}}>
                                    Routes { selectedRoutes.map(route => route.routeName).join(", ") } will be merged into single route
                            </Grid>
                        </Grid>

                        <Grid container spacing={24} classes={{root: classes.fields}}>
                                <Grid item xs={12} sm={6} >
                                    New route name
                                </Grid>
                                <Grid item xs={12} sm={6} classes={{item: `${classes.editorContainer} ${this.state.error ? classes.inputError:''}`}} >
                                    <TextFieldEditor
                                            ref={(node) => (this.editorRef = node)}
                                            column={{
                                                colDef: {
                                                cellEditorParams: {
                                                    ...this.props.configJSON?.routeNameEditParams,
                                                },
                                                },
                                            }}
                                        value={selectedRoutes[0].routeName}
                                        classes={{root: 'input'}}
                                        onChange={this.onRouteNameChange}
                                    />
                                </Grid>
                        </Grid>

                        { this.state.error &&
                            <Grid container spacing={24}>
                                <Grid item xs={12} classes={{item: classes.errorMessage}}>
                                    { this.state.error}
                                </Grid>
                            </Grid>
                        }
                    </DialogContent>
                    <DialogActions classes={{root:classes.dialogAction}}>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="medium"
                            className={classes.button}
                            onClick={this.props.close}>
                                Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            className={classes.button}
                            onClick={this.confirm}>
                                Confirm
                        </Button>
                </DialogActions>
                </Dialog>
            </div>
        )
    }

}

export default compose(withStyles(styles), withAppConfig)(MergeRoutesDialog);